import type { Dispatch, SetStateAction } from "react";
import { t } from "@/i18n-js/instance";
import { ContentFilterDropdown } from "@/react/components/shared/ContentFilterDropDown";

const i18nRoot = "settings.workflows.table.type";

export type TemplateType = "all" | "dynamic" | "bulk_action";

export const TemplateFilter = ({
  selectedTemplateType,
  setSelectedTemplateType,
}: {
  selectedTemplateType: TemplateType;
  setSelectedTemplateType: Dispatch<SetStateAction<TemplateType>>;
}) => {
  const OPTIONS: { label: string; value: TemplateType }[] = [
    {
      label: t([i18nRoot, "all"]),
      value: "all",
    },
    {
      label: t([i18nRoot, "dynamic"]),
      value: "dynamic",
    },
    {
      label: t([i18nRoot, "bulk_action"]),
      value: "bulk_action",
    },
  ];

  return (
    <ContentFilterDropdown
      selectedTemplateType={selectedTemplateType}
      setSelectedTemplateType={setSelectedTemplateType}
      options={OPTIONS}
      translationKey={i18nRoot}
    />
  );
};
